import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';
import { cn } from '../../lib/utils';

export function Breadcrumbs() {
    const location = useLocation();
    const pathnames = location.pathname.split('/').filter((x) => x);

    return (
        <nav aria-label="Breadcrumb" className="flex items-center text-sm text-muted-foreground">
            <Link
                to="/control-tower"
                className="flex items-center hover:text-foreground transition-colors"
                aria-label="Home"
            >
                <Home className="h-4 w-4" />
            </Link>

            {pathnames.length > 0 && (
                <ChevronRight className="h-4 w-4 mx-2 text-muted-foreground/50" />
            )}

            {pathnames.map((value, index) => {
                const to = `/${pathnames.slice(0, index + 1).join('/')}`;
                const isLast = index === pathnames.length - 1;

                // Format the label: remove hyphens, capitalize
                const label = value
                    .replace(/-/g, ' ')
                    .replace(/\b\w/g, (char) => char.toUpperCase());

                return (
                    <div key={to} className="flex items-center">
                        {isLast ? (
                            <span className="font-medium text-foreground cursor-default" aria-current="page">
                                {label}
                            </span>
                        ) : (
                            <Link
                                to={to}
                                className="hover:text-foreground transition-colors"
                            >
                                {label}
                            </Link>
                        )}
                        {!isLast && (
                            <ChevronRight className="h-4 w-4 mx-2 text-muted-foreground/50" />
                        )}
                    </div>
                );
            })}
        </nav>
    );
}
